import React from "react";
import cn from "classnames";

const names = ["white", "blue", "overlay"];

const defaultThemeProps = {
  name: names[0],
  styles: null,
};

const Theme = React.createContext(defaultThemeProps);

function createThemedStyles(baseStyles, themeStyles) {
  if (!themeStyles) return baseStyles;

  const mergedStyles = Object.assign({}, baseStyles);

  // Join base & theme classes
  Object.entries(mergedStyles).forEach(([key, value]) => {
    if (themeStyles[key]) {
      mergedStyles[key] = cn(value, themeStyles[key]);
    }
  });

  // Fill in theme-only classes
  Object.entries(themeStyles).forEach(([key, value]) => {
    if (!mergedStyles[key]) {
      mergedStyles[key] = value;
    }
  });

  return mergedStyles;
}

function provideTheme(Component, styles, themes) {
  return function ThemeProviderWrapper({ theme: initialTheme, ...props }) {
    let name = initialTheme || defaultThemeProps.name;

    if (typeof window !== "undefined" && window.GLOBAL_UI_INITIAL_PROPS) {
      name = window.GLOBAL_UI_INITIAL_PROPS.theme || name;
    }

    const themeProps = {
      ...defaultThemeProps,
      name,
      styles: createThemedStyles(styles, themes && themes[name]),
    };

    return (
      <Theme.Provider value={themeProps}>
        <Component {...props} theme={themeProps} />
      </Theme.Provider>
    );
  };
}

function withTheme(Component, styles, themes) {
  return function ThemedComponent(props) {
    return (
      <Theme.Consumer>
        {({ name }) => (
          <Component
            {...props}
            theme={{
              name,
              styles: createThemedStyles(styles, themes && themes[name]),
            }}
          />
        )}
      </Theme.Consumer>
    );
  };
}

export { provideTheme, withTheme };

export default Theme;
